import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import { PayChargePopupRepository } from "../domain/PayChargePopupRepository";

export class ApiPayChargePopupRepository implements PayChargePopupRepository {
    query_dispatcher: QueryDispatcher;
    sync_command_dispatcher: CommandDispatcher;

    constructor() {
        this.query_dispatcher = query_dispatcher;
        this.sync_command_dispatcher = sync_command_dispatcher;
    }

    async getUserTax(args: object): Promise<any> {
        try {
            return await this.query_dispatcher.dispatch("get.user.tax", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async rememberUsedCard(args: object): Promise<any> {
        try {
            return await this.query_dispatcher.dispatch("retrieve.stripe.payment.method", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async payByTransfer(args: object): Promise<any> {
        try {
            return await this.sync_command_dispatcher.dispatch("pay.charge.by.transfer", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async payWithOldCard(args: object): Promise<any> {
        try {
            return await this.sync_command_dispatcher.dispatch("create.stripe.payment.intent.for.pay.charge", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async payWithNewCard(args: object): Promise<any> {
        try {
            return await this.sync_command_dispatcher.dispatch("create.stripe.session.for.pay.charge", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}
